import * as React from 'react'
import './instagram-carousel.css'

export default class InstagramCarousel extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      apiPhotos: null,
      frontpage: this.props.frontpage,
    }
  }

  componentDidMount() {
    this.yourFunctionName()
  }

  yourFunctionName = async () => {
    const apiCall = await fetch(
      `https://graph.instagram.com/me/media?fields=media_url&access_token=IGQVJVVmlkSlZAmVXhOV0pnUkZAQVnNPT2VLVGYyODYyam84NEZAmbU83OTlKdWFkS3JBUEtDWThfd0R3QUp0dGk4MlNFRjV2NW1PaldBN055ZAzR1eDZAhajVLU21yaTV4Nm1RWGhSQnFqaFIxc1JwZA282eQZDZD`,
    )
    const data = await apiCall.json()
    if (data.data !== undefined) {
      this.setState({ apiPhotos: data.data.slice(0, 4) })
    }
  }

  render() {
    const apiPhotos = this.state.apiPhotos
    const frontpage = this.state.frontpage ? 'instagram frontpage' : 'instagram'
    return (
      <div className={frontpage}>
        <div className="item-container instagram-header-container">
          <h2>Fylgstu með okkur á Instagram</h2>
          <div className="instagram-link-container">
            <a
              href="https://www.instagram.com/ebson.reykjavik/"
              className="link"
              target="_blank"
            >
              Skoða prófíl
            </a>
          </div>
        </div>
        <div className="instagram-image-container item-container">
          {apiPhotos != null &&
            Object.keys(apiPhotos).map((key) => {
              const correctClassName =
                parseInt(key, 10) !== apiPhotos.length - 1
                  ? 'instagram-image instagram-gutter'
                  : 'instagram-image '
              return (
                <a
                  href="https://www.instagram.com/ebson.reykjavik/"
                  target="_blank"
                  key={key}
                >
                  <div
                    className={correctClassName}
                    style={{
                      backgroundImage: `url(${apiPhotos[key].media_url})`,
                    }}
                  />
                </a>
              )
            })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/front-page/instagram-carousel/instagram-carousel.tsx